import { useNavigate } from "react-router-dom";

const ShippingPolicy = () => {
  const navigate = useNavigate();
  return (
    <main className="dashboardLayoutSubSection rounded-xl">
      <section className="max-w-4xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="bg-myButtonBg hover:bg-myLabelText cursor-pointer text-white px-6 py-2 rounded-md"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Shipping Policy
        </h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Last Updated: 27th September, 2025
        </p>

        <p className="text-gray-600 mb-6">
          At LLB360, a product of Saadruso Internet Media Pvt. Ltd., we provide
          educational resources in both digital format (online courses, notes,
          and test material) and, where applicable, physical format (printed
          study guides, merchandise, or supplementary materials). This Shipping
          Policy outlines the terms and conditions related to delivery of such
          items.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            <span className="font-semibold text-gray-800">
              Digital Products (Default for LLB360)
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                <span className="font-semibold">Instant Access:</span> Digital
                courses, notes, and practice tests are delivered immediately
                upon purchase through your registered account.
              </li>
              <li>
                <span className="font-semibold">No Shipping Charges:</span>{" "}
                Since digital resources are delivered online, no shipping or
                handling fees apply.
              </li>
              <li>
                <span className="font-semibold">Delivery Confirmation:</span> A
                confirmation email will be sent with details of your
                subscription or access link.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Physical Products (If Offered)
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                <span className="font-semibold">a) Processing Time</span>
                <ul className="list-disc list-inside pl-6 mt-2 space-y-1">
                  <li>
                    Orders are typically processed within 2–4 business days
                    after payment confirmation.
                  </li>
                  <li>
                    Email notification will be sent once your order has been
                    dispatched.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">
                  b) Shipping Methods & Timeframes
                </span>
                <ul className="list-disc list-inside pl-6 mt-2 space-y-1">
                  <li>
                    Domestic Shipping (India): Delivery within 5–10 business
                    days.
                  </li>
                  <li>
                    International Shipping: Delivery between 10–21 business
                    days, subject to customs clearance.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">c) Shipping Charges</span>
                <ul className="list-disc list-inside pl-6 mt-2 space-y-1">
                  <li>
                    Calculated at checkout based on destination, weight, and
                    delivery method.
                  </li>
                  <li>
                    Free shipping may be offered during promotions or for bulk
                    orders.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">d) Tracking</span>
                <ul className="list-disc list-inside pl-6 mt-2 space-y-1">
                  <li>
                    Once dispatched, you will receive a tracking number to
                    monitor your shipment.
                  </li>
                  <li>Tracking updates may take 24–48 hours to reflect.</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Delivery Issues</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                <span className="font-semibold">Incorrect Address:</span>{" "}
                Customers are responsible for accurate delivery information.
                Returned orders may incur additional charges.
              </li>
              <li>
                <span className="font-semibold">Delays:</span> We are not
                responsible for courier delays, natural calamities, or customs
                clearance.
              </li>
              <li>
                <span className="font-semibold">Damaged or Lost Items:</span>{" "}
                Notify us within 7 days of delivery at{" "}
                <a
                  href="mailto:contact@llb360.com"
                  className="text-gray-600 underline"
                >
                  contact@llb360.com
                </a>{" "}
                for assistance with replacement or refund.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Non-Delivery of Digital Products
            </span>
            <p className="mt-2 text-gray-600">
              If you do not receive digital course access or materials within 24
              hours of purchase, please contact us at{" "}
              <a
                href="mailto:contact@llb360.com"
                className="text-gray-600 underline"
              >
                contact@llb360.com
              </a>{" "}
              with your order details.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Contact Us</span>
            <p className="mt-2 text-gray-600">
              For any queries regarding shipping, please contact:
            </p>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Saadruso Internet Media Pvt. Ltd.</li>
              <li>Email: contact@llb360.com</li>
              <li>Phone: 7673937360</li>
              <li>
                Address: 28, Doyens Township, Serilingampally, Hyderabad - 500
                019
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default ShippingPolicy;
